<template>
  <article
    class="animate-pulse bg-gray-800 rounded-sm shadow-md transform hover:-translate-y-1 transition-transform duration-100 ease-in"
  >
    <figure class="aspect-w-1 aspect-h-1 overflow-hidden" />
    <div class="py-4 px-5 text-gray-200 space-y-3">
      <p class="h-6 bg-gray-700" />
    </div>
  </article>
</template>
